var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pa-5"},[_c('v-select',{attrs:{"items":_vm.items,"item-text":"label","item-value":"deviceId"},on:{"input":_vm.changeMicro},model:{value:(_vm.selectedMedia),callback:function ($$v) {_vm.selectedMedia=$$v},expression:"selectedMedia"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }